import People from "../People";


const Dashboard = () => {
  return (
    <>
      <People />
    </>
  );
};

export default Dashboard;
